import {
  FunctionComponent,
  PropsWithChildren,
  ReactNode,
  RefObject,
} from 'react';

import { cn } from '../../helpers/classBuilders';

interface TabItemProps extends PropsWithChildren {
  group?: string;
  title: string;
  className?: string;
  forwardedRef?: RefObject<HTMLLIElement>;
  onClick?: (eventKey: string) => void;
  eventKey: string;
  navigation?: boolean;
  icon?: ReactNode;
  onlyRenderOnActive?: boolean;
  classBuilder?: () => string;
  isActive?: boolean;
}

const TabItem: FunctionComponent<TabItemProps> = ({
  title,
  className,
  forwardedRef,
  onClick,
  eventKey,
  navigation,
  icon,
  classBuilder = (arg: string) => arg,
  isActive,
}) => {
  const c = classBuilder;
  return (
    <li
      className={className}
      role="presentation"
      key={`tablist-${eventKey}`}
      ref={forwardedRef}
    >
      <button
        className={cn(
          c('__tabs_item__button'),
          'focus-visible:focus-ring-inset',
        )}
        onClick={() => {
          onClick(eventKey);
        }}
        role="tab"
        tabIndex={navigation ? -1 : 0}
        data-cy={`tabitem-${eventKey.toLowerCase()}`}
      >
        <div className={c('__tabs_item--label')}>
          {icon ? <div className={c('__tabs_item--icon')}>{icon}</div> : <></>}
          <span
            className={cn('text-gray-600 font-bold text-sm', {
              'text-gray-900': isActive,
            })}
          >
            {title}
          </span>
        </div>
      </button>
    </li>
  );
};

export default TabItem;
